import React from "react";
import "../../Utils/sd-styles/sd-home.scss";
import {sd_404} from "../../Assets/imageList";
const Sd_404 = () => {
  return (
    <div className="sd-coming-soon" style={{flexDirection: "column"}}>
      {/* <img src={SD_Logo_circle} alt="logo" /> */}
      <img
        // style={{marginTop: "-50px"}}
        src={sd_404}
        alt="404"
        height="80%"
      />
      <p style={{marginTop: "-50px"}}>Oops!! Page not found</p>
    </div>
  );
};
export default Sd_404;
